import React from 'react'
import UserHeader from './UserHeader'
import UserFooter from './UserFooter'

function Index2() {
  return (
    <div>
        <UserHeader/>
        <main className="main">
  <div className="intro-section bg-lighter pt-5 pb-6">
    <div className="container">
      <div className="row">
        <div className="col-lg-8">
          <div className="intro-slider-container slider-container-ratio slider-container-1 mb-2 mb-lg-0">
            <div className="intro-slider intro-slider-1 owl-carousel owl-simple owl-light owl-nav-inside" data-toggle="owl" data-owl-options="{
                      &quot;nav&quot;: false, 
                      &quot;responsive&quot;: {
                          &quot;768&quot;: {
                              &quot;nav&quot;: true
                          }
                      }
                  }">
              <div className="intro-slide">
                <figure className="slide-image">
                  <picture>
                    <source media="(max-width: 480px)" srcSet="asset/images/slider/slide-1-480w.jpg" />
                    <img src="asset/images/slider/slide-1.jpg" alt="Image Desc" />
                  </picture>
                </figure>{/* End .slide-image */}
                <div className="intro-content">
                  <h3 className="intro-subtitle">Topsale Collection</h3>{/* End .h3 intro-subtitle */}
                  <h1 className="intro-title">Living Room<br />Furniture</h1>{/* End .intro-title */}
                  <a href="category.html" className="btn btn-outline-white">
                    <span>SHOP NOW</span>
                    <i className="icon-long-arrow-right" />
                  </a>
                </div>{/* End .intro-content */}
              </div>{/* End .intro-slide */}
              <div className="intro-slide">
                <figure className="slide-image">
                  <picture>
                    <source media="(max-width: 480px)" srcSet="asset/images/slider/slide-2-480w.jpg" />
                    <img src="asset/images/slider/slide-2.jpg" alt="Image Desc" />
                  </picture>
                </figure>{/* End .slide-image */}
                <div className="intro-content">
                  <h3 className="intro-subtitle">News and Inspiration</h3>{/* End .h3 intro-subtitle */}
                  <h1 className="intro-title">New Arrivals</h1>{/* End .intro-title */}
                  <a href="category.html" className="btn btn-outline-white">
                    <span>SHOP NOW</span>
                    <i className="icon-long-arrow-right" />
                  </a>
                </div>{/* End .intro-content */}
              </div>{/* End .intro-slide */}
              <div className="intro-slide">
                <figure className="slide-image">
                  <picture>
                    <source media="(max-width: 480px)" srcSet="asset/images/slider/slide-3-480w.jpg" />
                    <img src="asset/images/slider/slide-3.jpg" alt="Image Desc" />
                  </picture>
                </figure>{/* End .slide-image */}
                <div className="intro-content">
                  <h3 className="intro-subtitle">Outdoor Furniture</h3>{/* End .h3 intro-subtitle */}
                  <h1 className="intro-title">Outdoor Dining <br />Furniture</h1>{/* End .intro-title */}
                  <a href="category.html" className="btn btn-outline-white">
                    <span>SHOP NOW</span>
                    <i className="icon-long-arrow-right" />
                  </a>
                </div>{/* End .intro-content */}
              </div>{/* End .intro-slide */}
            </div>{/* End .intro-slider owl-carousel owl-simple */}
            <span className="slider-loader" />{/* End .slider-loader */}
          </div>{/* End .intro-slider-container */}
        </div>{/* End .col-lg-8 */}
        <div className="col-lg-4">
          <div className="intro-banners">
            <div className="row row-sm">
              <div className="col-md-6 col-lg-12">
                <div className="banner banner-display">
                  <a href="#">
                    <img src="asset/images/banners/home/intro/banner-1.jpg" alt="Banner" />
                  </a>
                  <div className="banner-content">
                    <h4 className="banner-subtitle text-darkwhite"><a href="#">Clearence</a></h4>{/* End .banner-subtitle */}
                    <h3 className="banner-title text-white"><a href="#">Chairs &amp; Chaises <br />Up to 40% off</a></h3>{/* End .banner-title */}
                    <a href="#" className="btn btn-outline-white banner-link">Shop Now<i className="icon-long-arrow-right" /></a>
                  </div>{/* End .banner-content */}
                </div>{/* End .banner */}
              </div>{/* End .col-md-6 col-lg-12 */}
              <div className="col-md-6 col-lg-12">
                <div className="banner banner-display mb-0">
                  <a href="#">
                    <img src="asset/images/banners/home/intro/banner-2.jpg" alt="Banner" />
                  </a>
                  <div className="banner-content">
                    <h4 className="banner-subtitle text-darkwhite"><a href="#">New in</a></h4>{/* End .banner-subtitle */}
                    <h3 className="banner-title text-white"><a href="#">Best Lighting <br />Collection</a></h3>{/* End .banner-title */}
                    <a href="#" className="btn btn-outline-white banner-link">Discover Now<i className="icon-long-arrow-right" /></a>
                  </div>{/* End .banner-content */}
                </div>{/* End .banner */}
              </div>{/* End .col-md-6 col-lg-12 */}
            </div>{/* End .row row-sm */}
          </div>{/* End .intro-banners */}
        </div>{/* End .col-lg-4 */}
      </div>{/* End .row */}
      <div className="mb-6" />{/* End .mb-6 */}
      <div className="owl-carousel owl-simple" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: false,
          &quot;margin&quot;: 30,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:2
              },
              &quot;420&quot;: {
                  &quot;items&quot;:3
              },
              &quot;600&quot;: {
                  &quot;items&quot;:4
              },
              &quot;900&quot;: {
                  &quot;items&quot;:5
              },
              &quot;1024&quot;: {
                  &quot;items&quot;:6
              }
          }
      }">
        <a href="#" className="brand">
          <img src="asset/images/brands/1.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/2.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/3.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/4.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/5.png" alt="Brand Name" />
        </a>
        <a href="#" className="brand">
          <img src="asset/images/brands/6.png" alt="Brand Name" />
        </a>
      </div>{/* End .owl-carousel */}
    </div>{/* End .container */}
  </div>{/* End .bg-lighter */}
  <div className="mb-6" />{/* End .mb-6 */}
  <div className="container">
    <div className="heading heading-center mb-3">
      <h2 className="title-lg">Trendy Products</h2>{/* End .title */}
      <ul className="nav nav-pills justify-content-center" role="tablist">
        <li className="nav-item">
          <a className="nav-link active" id="trendy-all-link" data-toggle="tab" href="#trendy-all-tab" role="tab" aria-controls="trendy-all-tab" aria-selected="true">All</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="trendy-fur-link" data-toggle="tab" href="#trendy-fur-tab" role="tab" aria-controls="trendy-fur-tab" aria-selected="false">Furniture</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="trendy-decor-link" data-toggle="tab" href="#trendy-decor-tab" role="tab" aria-controls="trendy-decor-tab" aria-selected="false">Decor</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="trendy-light-link" data-toggle="tab" href="#trendy-light-tab" role="tab" aria-controls="trendy-light-tab" aria-selected="false">Lighting</a>
        </li>
      </ul>
    </div>{/* End .heading */}
    <div className="tab-content tab-content-carousel">
      <div className="tab-pane p-0 fade show active" id="trendy-all-tab" role="tabpanel" aria-labelledby="trendy-all-link">
        <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
              &quot;nav&quot;: false, 
              &quot;dots&quot;: true,
              &quot;margin&quot;: 20,
              &quot;loop&quot;: false,
              &quot;responsive&quot;: {
                  &quot;0&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;480&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;768&quot;: {
                      &quot;items&quot;:3
                  },
                  &quot;992&quot;: {
                      &quot;items&quot;:4
                  },
                  &quot;1200&quot;: {
                      &quot;items&quot;:4,
                      &quot;nav&quot;: true,
                      &quot;dots&quot;: false
                  }
              }
          }">
          <div className="product product-11 text-center">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-1-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Butler Stool Ladder</a></h3>{/* End .product-title */}
              <div className="product-price">
                $251,00
              </div>{/* End .product-price */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
          <div className="product product-11 text-center">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-2-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-2-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Octo 4240</a></h3>{/* End .product-title */}
              <div className="product-price">
                $746,00
              </div>{/* End .product-price */}
              <div className="product-nav product-nav-dots">
                <a href="#" className="active" style={{background: '#1f1e18'}}><span className="sr-only">Color name</span></a>
                <a href="#" style={{background: '#e8e8e8'}}><span className="sr-only">Color name</span></a>
              </div>{/* End .product-nav */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
          <div className="product product-11 text-center">
            <figure className="product-media">
              <span className="product-label label-new">NEW</span>
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-3-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Flow Slim Armchair</a></h3>{/* End .product-title */}
              <div className="product-price">
                $970,00
              </div>{/* End .product-price */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
          <div className="product product-11 text-center">
            <figure className="product-media">
              <span className="product-label label-sale">30% OFF</span>
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-4-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Roots Sofa Bed</a></h3>{/* End .product-title */}
              <div className="product-price">
                <span className="new-price">$337,00</span>
                <span className="old-price">Was $449,00</span>
              </div>{/* End .product-price */}
              <div className="product-nav product-nav-dots">
                <a href="#" className="active" style={{background: '#878883'}}><span className="sr-only">Color name</span></a>
                <a href="#" style={{background: '#dfd5c2'}}><span className="sr-only">Color name</span></a>
              </div>{/* End .product-nav */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
          <div className="product product-11 text-center">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-5-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Petite Table Lamp</a></h3>{/* End .product-title */}
              <div className="product-price">
                $675,00
              </div>{/* End .product-price */}
              <div className="product-nav product-nav-dots">
                <a href="#" className="active" style={{background: '#74543e'}}><span className="sr-only">Color name</span></a>
                <a href="#" style={{background: '#e8e8e8'}}><span className="sr-only">Color name</span></a>
              </div>{/* End .product-nav */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
          <div className="product product-11 text-center">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-6-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Elephant Armchair</a></h3>{/* End .product-title */}
              <div className="product-price">
                $457,00
              </div>{/* End .product-price */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
          <div className="product product-11 text-center">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-1-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Butler Stool Ladder</a></h3>{/* End .product-title */}
              <div className="product-price">
                $251,00
              </div>{/* End .product-price */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
        </div>{/* End .owl-carousel */}
      </div>{/* .End .tab-pane */}
      <div className="tab-pane p-0 fade" id="trendy-fur-tab" role="tabpanel" aria-labelledby="trendy-fur-link">
        <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
              &quot;nav&quot;: false, 
              &quot;dots&quot;: true,
              &quot;margin&quot;: 20,
              &quot;loop&quot;: false,
              &quot;responsive&quot;: {
                  &quot;0&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;480&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;768&quot;: {
                      &quot;items&quot;:3
                  },
                  &quot;992&quot;: {
                      &quot;items&quot;:4
                  },
                  &quot;1200&quot;: {
                      &quot;items&quot;:4,
                      &quot;nav&quot;: true,
                      &quot;dots&quot;: false
                  }
              }
          }">
          <div className="product product-11 text-center">
            <figure className="product-media">
              <span className="product-label label-new">NEW</span>
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-3-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-3-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Flow Slim Armchair</a></h3>{/* End .product-title */}
              <div className="product-price">
                $970,00
              </div>{/* End .product-price */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
          <div className="product product-11 text-center">
            <figure className="product-media">
              <span className="product-label label-sale">30% OFF</span>
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-4-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-4-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Roots Sofa Bed</a></h3>{/* End .product-title */}
              <div className="product-price">
                <span className="new-price">$337,00</span>
                <span className="old-price">Was $449,00</span>
              </div>{/* End .product-price */}
              <div className="product-nav product-nav-dots">
                <a href="#" className="active" style={{background: '#878883'}}><span className="sr-only">Color name</span></a>
                <a href="#" style={{background: '#dfd5c2'}}><span className="sr-only">Color name</span></a>
              </div>{/* End .product-nav */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
        </div>{/* End .owl-carousel */}
      </div>{/* .End .tab-pane */}
      <div className="tab-pane p-0 fade" id="trendy-decor-tab" role="tabpanel" aria-labelledby="trendy-decor-link">
        <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
              &quot;nav&quot;: false, 
              &quot;dots&quot;: true,
              &quot;margin&quot;: 20,
              &quot;loop&quot;: false,
              &quot;responsive&quot;: {
                  &quot;0&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;480&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;768&quot;: {
                      &quot;items&quot;:3
                  },
                  &quot;992&quot;: {
                      &quot;items&quot;:4
                  },
                  &quot;1200&quot;: {
                      &quot;items&quot;:4,
                      &quot;nav&quot;: true,
                      &quot;dots&quot;: false
                  }
              }
          }">
          <div className="product product-11 text-center">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-1-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-1-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Butler Stool Ladder</a></h3>{/* End .product-title */}
              <div className="product-price">
                $251,00
              </div>{/* End .product-price */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
          <div className="product product-11 text-center">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-6-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-6-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Elephant Armchair</a></h3>{/* End .product-title */}
              <div className="product-price">
                $457,00
              </div>{/* End .product-price */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
        </div>{/* End .owl-carousel */}
      </div>{/* .End .tab-pane */}
      <div className="tab-pane p-0 fade" id="trendy-light-tab" role="tabpanel" aria-labelledby="trendy-light-link">
        <div className="owl-carousel owl-simple carousel-equal-height carousel-with-shadow" data-toggle="owl" data-owl-options="{
              &quot;nav&quot;: false, 
              &quot;dots&quot;: true,
              &quot;margin&quot;: 20,
              &quot;loop&quot;: false,
              &quot;responsive&quot;: {
                  &quot;0&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;480&quot;: {
                      &quot;items&quot;:2
                  },
                  &quot;768&quot;: {
                      &quot;items&quot;:3
                  },
                  &quot;992&quot;: {
                      &quot;items&quot;:4
                  },
                  &quot;1200&quot;: {
                      &quot;items&quot;:4,
                      &quot;nav&quot;: true,
                      &quot;dots&quot;: false
                  }
              }
          }">
          <div className="product product-11 text-center">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-2-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-2-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Octo 4240</a></h3>{/* End .product-title */}
              <div className="product-price">
                $746,00
              </div>{/* End .product-price */}
              <div className="product-nav product-nav-dots">
                <a href="#" className="active" style={{background: '#1f1e18'}}><span className="sr-only">Color name</span></a>
                <a href="#" style={{background: '#e8e8e8'}}><span className="sr-only">Color name</span></a>
              </div>{/* End .product-nav */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
          <div className="product product-11 text-center">
            <figure className="product-media">
              <a href="product.html">
                <img src="asset/images/demos/demo-2/products/product-5-1.jpg" alt="Product image" className="product-image" />
                <img src="asset/images/demos/demo-2/products/product-5-2.jpg" alt="Product image" className="product-image-hover" />
              </a>
              <div className="product-action-vertical">
                <a href="#" className="btn-product-icon btn-wishlist"><span>add to wishlist</span></a>
              </div>{/* End .product-action-vertical */}
            </figure>{/* End .product-media */}
            <div className="product-body">
              <h3 className="product-title"><a href="product.html">Petite Table Lamp</a></h3>{/* End .product-title */}
              <div className="product-price">
                $675,00
              </div>{/* End .product-price */}
              <div className="product-nav product-nav-dots">
                <a href="#" className="active" style={{background: '#74543e'}}><span className="sr-only">Color name</span></a>
                <a href="#" style={{background: '#e8e8e8'}}><span className="sr-only">Color name</span></a>
              </div>{/* End .product-nav */}
            </div>{/* End .product-body */}
            <div className="product-action">
              <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
            </div>{/* End .product-action */}
          </div>{/* End .product */}
        </div>{/* End .owl-carousel */}
      </div>{/* .End .tab-pane */}
    </div>{/* End .tab-content */}
  </div>{/* End .container */}
  <div className="container categories pt-6">
    <h2 className="title-lg text-center mb-4">Shop by Categories</h2>{/* End .title-lg text-center */}
    <div className="row">
      <div className="col-6 col-lg-4">
        <div className="banner banner-display banner-link-anim">
          <a href="#">
            <img src="asset/images/banners/home/banner-1.jpg" alt="Banner" />
          </a>
          <div className="banner-content banner-content-center">
            <h3 className="banner-title text-white"><a href="#">Outdoor</a></h3>{/* End .banner-title */}
            <a href="#" className="btn btn-outline-white banner-link">Shop Now<i className="icon-long-arrow-right" /></a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-sm-6 col-lg-3 */}
      <div className="col-6 col-lg-4 order-lg-last">
        <div className="banner banner-display banner-link-anim">
          <a href="#">
            <img src="asset/images/banners/home/banner-4.jpg" alt="Banner" />
          </a>
          <div className="banner-content banner-content-center">
            <h3 className="banner-title text-white"><a href="#">Lighting</a></h3>{/* End .banner-title */}
            <a href="#" className="btn btn-outline-white banner-link">Shop Now<i className="icon-long-arrow-right" /></a>
          </div>{/* End .banner-content */}
        </div>{/* End .banner */}
      </div>{/* End .col-sm-6 col-lg-3 */}
      <div className="col-sm-12 col-lg-4 banners-sm">
        <div className="row">
          <div className="banner banner-display banner-link-anim col-lg-12 col-6">
            <a href="#">
              <img src="asset/images/banners/home/banner-2.jpg" alt="Banner" />
            </a>
            <div className="banner-content banner-content-center">
              <h3 className="banner-title text-white"><a href="#">Furniture and Design</a></h3>{/* End .banner-title */}
              <a href="#" className="btn btn-outline-white banner-link">Shop Now<i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
          <div className="banner banner-display banner-link-anim col-lg-12 col-6">
            <a href="#">
              <img src="asset/images/banners/home/banner-3.jpg" alt="Banner" />
            </a>
            <div className="banner-content banner-content-center">
              <h3 className="banner-title text-white"><a href="#">Kitchen &amp; Utensil</a></h3>{/* End .banner-title */}
              <a href="#" className="btn btn-outline-white banner-link">Shop Now<i className="icon-long-arrow-right" /></a>
            </div>{/* End .banner-content */}
          </div>{/* End .banner */}
        </div>
      </div>{/* End .col-sm-6 col-lg-3 */}
    </div>{/* End .row */}
  </div>{/* End .container */}
  <div className="mb-5" />{/* End .mb-6 */}
  <div className="container">
    <div className="heading heading-center mb-6">
      <h2 className="title">Recent Arrivals</h2>{/* End .title */}
      <ul className="nav nav-pills nav-border-anim justify-content-center" role="tablist">
        <li className="nav-item">
          <a className="nav-link active" id="top-all-link" data-toggle="tab" href="#top-all-tab" role="tab" aria-controls="top-all-tab" aria-selected="true">All</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="top-fur-link" data-toggle="tab" href="#top-fur-tab" role="tab" aria-controls="top-fur-tab" aria-selected="false">Furniture</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="top-decor-link" data-toggle="tab" href="#top-decor-tab" role="tab" aria-controls="top-decor-tab" aria-selected="false">Decor</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="top-light-link" data-toggle="tab" href="#top-light-tab" role="tab" aria-controls="top-light-tab" aria-selected="false">Lighting</a>
        </li>
      </ul>
    </div>{/* End .heading */}
    <div className="tab-content">
      <div className="tab-pane p-0 fade show active" id="top-all-tab" role="tabpanel" aria-labelledby="top-all-link">
        <div className="products">
          <div className="row justify-content-center">
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-12-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-12-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Block Side Table/Trolley</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $229,00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#e8e8e8'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-10-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-10-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Carronade Suspension Lamp</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $892,00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#e8e8e8'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <span className="product-label label-new">NEW</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-9-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Garden Armchair</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $94,00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-8-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Madra Log Holder</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $104,00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#927764'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-11-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-11-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Original Outdoor Beanbag</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $259,00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-13-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-13-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">2-Seater</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $3.107,00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-14-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-14-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Wingback Chair</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $2.486,00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#999999'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#cc9999'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <span className="product-label label-new">NEW</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-16-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-16-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Decor</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Cushion Set 3 Pieces</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $199,00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          </div>{/* End .row */}
        </div>{/* End .products */}
      </div>{/* .End .tab-pane */}
      <div className="tab-pane p-0 fade" id="top-fur-tab" role="tabpanel" aria-labelledby="top-fur-link">
        <div className="products">
          <div className="row justify-content-center">
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <span className="product-label label-new">NEW</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-9-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-9-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Garden Armchair</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $94,00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-12-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-12-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Block Side Table/Trolley</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $229,00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#e8e8e8'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-13-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-13-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">2-Seater</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $3.107,00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          </div>{/* End .row */}
        </div>{/* End .products */}
      </div>{/* .End .tab-pane */}
      <div className="tab-pane p-0 fade" id="top-decor-tab" role="tabpanel" aria-labelledby="top-decor-link">
        <div className="products">
          <div className="row justify-content-center">
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-8-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-8-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Madra Log Holder</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $104,00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#927764'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-11-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-11-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Original Outdoor Beanbag</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $259,00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-14-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-14-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Wingback Chair</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $2.486,00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#999999'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#cc9999'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          </div>{/* End .row */}
        </div>{/* End .products */}
      </div>{/* .End .tab-pane */}
      <div className="tab-pane p-0 fade" id="top-light-tab" role="tabpanel" aria-labelledby="top-light-link">
        <div className="products">
          <div className="row justify-content-center">
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-10-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-10-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <h3 className="product-title"><a href="product.html">Carronade Suspension Lamp</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $892,00
                  </div>{/* End .product-price */}
                  <div className="product-nav product-nav-dots">
                    <a href="#" className="active" style={{background: '#e8e8e8'}}><span className="sr-only">Color name</span></a>
                    <a href="#" style={{background: '#333333'}}><span className="sr-only">Color name</span></a>
                  </div>{/* End .product-nav */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
            <div className="col-6 col-md-4 col-lg-3">
              <div className="product product-11 mt-v3 text-center">
                <figure className="product-media">
                  <span className="product-label label-new">NEW</span>
                  <a href="product.html">
                    <img src="asset/images/demos/demo-2/products/product-16-1.jpg" alt="Product image" className="product-image" />
                    <img src="asset/images/demos/demo-2/products/product-16-2.jpg" alt="Product image" className="product-image-hover" />
                  </a>
                  <div className="product-action-vertical">
                    <a href="#" className="btn-product-icon btn-wishlist "><span>add to wishlist</span></a>
                  </div>{/* End .product-action-vertical */}
                </figure>{/* End .product-media */}
                <div className="product-body">
                  <div className="product-cat">
                    <a href="#">Decor</a>
                  </div>{/* End .product-cat */}
                  <h3 className="product-title"><a href="product.html">Cushion Set 3 Pieces</a></h3>{/* End .product-title */}
                  <div className="product-price">
                    $199,00
                  </div>{/* End .product-price */}
                </div>{/* End .product-body */}
                <div className="product-action">
                  <a href="#" className="btn-product btn-cart"><span>add to cart</span></a>
                </div>{/* End .product-action */}
              </div>{/* End .product */}
            </div>{/* End .col-sm-6 col-md-4 col-lg-3 */}
          </div>{/* End .row */}
        </div>{/* End .products */}
      </div>{/* .End .tab-pane */}
    </div>{/* End .tab-content */}
    <div className="more-container text-center">
      <a href="#" className="btn btn-outline-darker btn-more"><span>Load more products</span><i className="icon-long-arrow-down" /></a>
    </div>{/* End .more-container */}
  </div>{/* End .container */}
  <div className="container">
    <hr />
    <div className="row justify-content-center">
      <div className="col-lg-4 col-sm-6">
        <div className="icon-box icon-box-card text-center">
          <span className="icon-box-icon">
            <i className="icon-rocket" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Payment &amp; Delivery</h3>{/* End .icon-box-title */}
            <p>Free shipping for orders over $50</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-lg-4 col-sm-6 */}
      <div className="col-lg-4 col-sm-6">
        <div className="icon-box icon-box-card text-center">
          <span className="icon-box-icon">
            <i className="icon-rotate-left" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Return &amp; Refund</h3>{/* End .icon-box-title */}
            <p>Free 100% money back guarantee</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-lg-4 col-sm-6 */}
      <div className="col-lg-4 col-sm-6">
        <div className="icon-box icon-box-card text-center">
          <span className="icon-box-icon">
            <i className="icon-life-ring" />
          </span>
          <div className="icon-box-content">
            <h3 className="icon-box-title">Quality Support</h3>{/* End .icon-box-title */}
            <p>Alway online feedback 24/7</p>
          </div>{/* End .icon-box-content */}
        </div>{/* End .icon-box */}
      </div>{/* End .col-lg-4 col-sm-6 */}
    </div>{/* End .row */}
    <div className="mb-2" />{/* End .mb-2 */}
  </div>{/* End .container */}
  <div className="blog-posts pt-7 pb-7" style={{backgroundColor: '#fafafa'}}>
    <div className="container">
      <h2 className="title-lg text-center mb-3 mb-md-4">From Our Blog</h2>{/* End .title-lg text-center */}
      <div className="owl-carousel owl-simple carousel-with-shadow" data-toggle="owl" data-owl-options="{
          &quot;nav&quot;: false, 
          &quot;dots&quot;: true,
          &quot;items&quot;: 3,
          &quot;margin&quot;: 20,
          &quot;loop&quot;: false,
          &quot;responsive&quot;: {
              &quot;0&quot;: {
                  &quot;items&quot;:1
              },
              &quot;600&quot;: {
                  &quot;items&quot;:2
              },
              &quot;992&quot;: {
                  &quot;items&quot;:3
              }
          }
      }">
        <article className="entry entry-display">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/blog/home/post-1.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body pb-4 text-center">
            <div className="entry-meta">
              <a href="#">Nov 22, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Sed adipiscing ornare.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Phasellus hendrerit.<br />Pelletesque aliquet nibh necurna. </p>
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry entry-display">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/blog/home/post-2.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body pb-4 text-center">
            <div className="entry-meta">
              <a href="#">Dec 12, 2018</a>, 0 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Fusce lacinia arcuet nulla.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Sed pretium, ligula sollicitudin laoreet<br />viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis justo. </p>
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
        <article className="entry entry-display">
          <figure className="entry-media">
            <a href="single.html">
              <img src="asset/images/blog/home/post-3.jpg" alt="image desc" />
            </a>
          </figure>{/* End .entry-media */}
          <div className="entry-body pb-4 text-center">
            <div className="entry-meta">
              <a href="#">Dec 19, 2018</a>, 2 Comments
            </div>{/* End .entry-meta */}
            <h3 className="entry-title">
              <a href="single.html">Quisque volutpat mattis eros.</a>
            </h3>{/* End .entry-title */}
            <div className="entry-content">
              <p>Suspendisse potenti. Sed egestas, ante et vulputate volutpat, eros pede semper est, vitae luctus metus libero eu augue. </p>
              <a href="single.html" className="read-more">Read More</a>
            </div>{/* End .entry-content */}
          </div>{/* End .entry-body */}
        </article>{/* End .entry */}
      </div>{/* End .owl-carousel */}
    </div>{/* container */}
    <div className="more-container text-center mb-0 mt-3">
      <a href="blog.html" className="btn btn-outline-darker btn-more"><span>View more articles</span><i className="icon-long-arrow-right" /></a>
    </div>{/* End .more-container */}
  </div>
  <div className="cta cta-display bg-image pt-4 pb-4" style={{backgroundImage: 'url(asset/images/backgrounds/cta/bg-6.jpg)'}}>
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-10 col-lg-9 col-xl-8">
          <div className="row no-gutters flex-column flex-sm-row align-items-sm-center">
            <div className="col">
              <h3 className="cta-title text-white">Sign Up &amp; Get 10% Off</h3>{/* End .cta-title */}
              <p className="cta-desc text-white">Molla presents the best in interior design</p>{/* End .cta-desc */}
            </div>{/* End .col */}
            <div className="col-auto">
              <a href="login.html" className="btn btn-outline-white"><span>SIGN UP</span><i className="icon-long-arrow-right" /></a>
            </div>{/* End .col-auto */}
          </div>{/* End .row no-gutters */}
        </div>{/* End .col-md-10 col-lg-9 */}
      </div>{/* End .row */}
    </div>{/* End .container */}
  </div>{/* End .cta */}
</main>

        <UserFooter/>

    </div>
  )
}

export default Index2